import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../services/firebase';

const FirestoreTest = () => {
  const [result, setResult] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const testFirestore = async () => {
    setLoading(true);
    setError('');
    setResult('');

    try {
      // Test reading from users collection
      const testUserId = 'test_user_123';
      const userRef = doc(db, 'users', testUserId);
      
      console.log('Testing Firestore read...');
      const userDoc = await getDoc(userRef);
      
      if (userDoc.exists()) {
        setResult('✅ Firestore read successful! User data found.');
        console.log('User data:', userDoc.data());
      } else {
        setResult('✅ Firestore read successful! No user data found (this is normal).');
      }

      // Test writing to users collection
      console.log('Testing Firestore write...');
      await setDoc(userRef, {
        test: true,
        timestamp: serverTimestamp(),
        message: 'This is a test document'
      });
      
      setResult(prev => prev + '\n✅ Firestore write successful! Test document created.');
      
    } catch (error) {
      console.error('Firestore test error:', error);
      setError(`❌ Firestore test failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">Firestore Database Test</h2>
      
      <div className="space-y-4">
        <button
          onClick={testFirestore}
          disabled={loading}
          className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Testing...' : 'Test Firestore Connection'}
        </button>

        {result && (
          <div className="bg-green-50 border border-green-200 text-green-600 px-4 py-3 rounded-md whitespace-pre-line">
            {result}
          </div>
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md">
            {error}
          </div>
        )}

        <div className="text-sm text-gray-600">
          <p><strong>What this test does:</strong></p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Tests reading from Firestore</li>
            <li>Tests writing to Firestore</li>
            <li>Checks if security rules are working</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FirestoreTest;
